import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';

import ScrollableDiv from '../../ScrollableDiv';
import IdentitySelectorAvatar from './IdentitySelectorAvatar';
import { setActiveIdentity as setActiveIdentityAction } from '../../../../services/checkout/redux/checkoutActions';
import { getPrintPackagesCountByIdentity } from '../helpers';
import PlusIcon from '../../../icons/PlusIcon';
import Button from '../../Button';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumFolderId: PropTypes.string.isRequired,
    }),
  }).isRequired,
  cart: PropTypes.array.isRequired,
  identities: PropTypes.array.isRequired,
  activeIdentity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  setActiveIdentity: PropTypes.func.isRequired,
  onAddFace: PropTypes.bool,
};

const IdentitySelector = ({
  history,
  match,
  cart,
  identities,
  activeIdentity,
  setActiveIdentity,
  onAddFace,
}) => {
  const { albumFolderId } = match.params;

  useEffect(() => {
    if (identities && !activeIdentity) {
      setActiveIdentity(identities[0]?.identity);
    }
  }, [identities]);

  if (!identities) {
    return null;
  }

  return (
    <div className="w-100 d-flex align-items-center justify-content-md-center mb-2">
      {onAddFace && (
        <Button
          btnStyle="link"
          className="d-flex flex-column align-items-center mr-1"
          onClick={() => {
            onAddFace();
            history.push(`/discover/album-folder/${albumFolderId}/faces`);
          }}
        >
          <div className="prepaid-print-packages-identity-selector-new">
            <PlusIcon color="white" size={24} />
          </div>
          <p className="mb-0 text-xs text-extra-bold text-primary mt-1">Add</p>
        </Button>
      )}
      <ScrollableDiv orientation="horizontal">
        <div className="identity-selector-container">
          {identities.map(membershipIdentity => {
            const identitySelectedPackages = getPrintPackagesCountByIdentity(
              cart,
              membershipIdentity.identity,
            );
            return (
              <IdentitySelectorAvatar
                key={membershipIdentity.identity.id}
                identity={membershipIdentity.identity}
                onClick={() => {
                  setActiveIdentity(membershipIdentity.identity);
                }}
                isActive={membershipIdentity.identity.id === activeIdentity?.id}
                packagesCount={identitySelectedPackages}
              />
            );
          })}
        </div>
      </ScrollableDiv>
    </div>
  );
};

IdentitySelector.propTypes = propTypes;

const mapStateToProps = ({ checkout }) => ({
  cart: checkout.cart,
  activeIdentity: checkout.activeIdentity,
});

const mapDispatchToProps = {
  setActiveIdentity: setActiveIdentityAction,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(IdentitySelector);
